import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Toolbar extends Component {
    constructor(props){
        super(props);
        this.handleAdd = this.handleAdd.bind(this);
    }

    handleAdd(e){
        return this.props.addFunction();
    }

    render() {
        return (
            <div>
                <a className="btn-floating primary-bkg text-white" onClick={this.handleAdd}><i className="fas fa-plus"></i></a>
            </div>
        );
    }
}

/*Toolbar.propTypes = {
    addFunction: PropTypes.func
};*/

export default Toolbar;


// WEBPACK FOOTER //
// ./src/components/Toolbar.js